import React, { useEffect, useState } from "react";
import { Col, Row, Card, Button, Form } from "@themesberg/react-bootstrap";
import { faFileAlt, faSyncAlt, faCheckCircle, faPlus, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CounterWidget } from "../../components/Widgets";
import CustomCalendar from "./CustomCalendar";
import API from "../../utils/api";
import { AllClaims } from "../../components/admin/AllClaims";
import { useTranslation } from "react-i18next";
import { faEuroSign } from "@fortawesome/free-solid-svg-icons";

export default () => {
  const { t, i18n } = useTranslation();
  const [stats, setStats] = useState([
    { title: t("overviewTotalClaims"), value: 0, icon: faFileAlt, color: "primary" },
    { title: t("overviewInProgress"), value: 0, icon: faSyncAlt, color: "warning" },
    { title: t("overviewClaimsClosed"), value: 0, icon: faCheckCircle, color: "success" },
    { title: t("overviewTotalAmount"), value: 0, icon: faEuroSign, color: "info" }
  ]);

  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState("");
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const fetchClaims = async () => {
      try {
        const response = await API.get("/claims/getall"); // 👈 admin API
        const { stats } = response.data;
        console.log("Stats:::", stats);

        setStats([
          { title: t("overviewTotalClaims"), value: stats.total, icon: faFileAlt, color: "primary" },
          { title: t("overviewInProgress"), value: stats.inProcess, icon: faSyncAlt, color: "warning" },
          { title: t("overviewClaimsClosed"), value: stats.closed, icon: faCheckCircle, color: "success" },
          { title: t("overviewTotalAmount"), value: stats?.totalAmount, icon: faEuroSign, color: "info" }
        ]);
      } catch (error) {
        console.error("Error fetching admin claims:", error);
      }
    };

    fetchClaims();
  }, [i18n.language]);
  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const res = await API.get("/notes"); // fetch only current admin's tasks
        setTasks(res.data);
      } catch (err) {
        console.error("Error fetching tasks:", err);
      }
    };
    fetchTasks();
  }, []);

  const handleAddTask = async () => {
    if (newTask.trim() === "") return;
    try {
      const res = await API.post("/notes", { text: newTask });
      setTasks([res.data, ...tasks]); // new task at the top
      // add new task from backend
      setNewTask("");
    } catch (err) {
      console.error("Error adding task:", err);
    }
  };

  const handleCompleteTask = async (id) => {
    try {
      await API.patch(`/notes/${id}/complete`);
      setTasks(tasks.filter((t) => t._id !== id)); // remove from UI
    } catch (err) {
      console.error("Error completing task:", err);
    }
  };


  const filterPaymentStatus = "Resubmissions";
  return (
    <>
      {/* Row 1 - Stats */}
      <Row className="justify-content-md-center mb-4">
        {stats.map((stat, index) => (
          <Col key={index} xs={12} sm={3} xl={3} className="mb-4">
            <CounterWidget
              category={stat.title}
              title={(stat.value ?? 0).toLocaleString()}
              period="June 1 - Aug 1"
              percentage={0}
              icon={stat.icon}
              iconColor={`shape-${stat.color}`}
            />
          </Col>
        ))}
      </Row>

      {/* Row 2 - Tasks + Calendar */}
      <Row className="mb-4">
        {/* Tasks */}
        <Col md={8} className="mb-4">
          <Card style={{ minHeight: "500px" }}>   {/* ✅ Card always enforces height */}
            <Card.Header>
              <strong>{t("overviewNotesFieldLable")}</strong>
            </Card.Header>
            <Card.Body
              style={{
                minHeight: "450px",  // ✅ give space inside body
                maxHeight: "450px",
                overflowY: "auto"
              }}
            >
              <div className="d-flex mb-3">
                <Form.Control
                  type="text"
                  placeholder={t("overviewNotesFieldPlaceholder")}
                  value={newTask}
                  onChange={(e) => setNewTask(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleAddTask()}
                />
                <Button variant="primary" className="ms-2" onClick={handleAddTask}>
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              </div>

              {tasks.length === 0 ? (
                <p className="text-muted">{t("overviewNotaksYet")}</p>
              ) : (
                <ul className="list-group">
                  {tasks.map((task) => (
                    <li
                      key={task._id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                      style={{
                        border: "1px solid #e0e0e0",   // light gray border
                        borderRadius: "6px",           // rounded corners
                        marginBottom: "8px",           // spacing between tasks
                        backgroundColor: "#f9f9f9",    // subtle gray background
                        padding: "10px 15px",          // internal spacing
                      }}
                    >
                      {task.text}
                      <Button
                        size="sm"
                        variant="success"
                        onClick={() => handleCompleteTask(task._id)}
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </Button>
                    </li>
                  ))}
                </ul>

              )}
            </Card.Body>
          </Card>
        </Col>



        {/* Calendar */}
        <Col md={4} className="mb-4">
          <Card
            style={{
              width: "100%",

              margin: "0 auto",

            }}
          >
            <Card.Header >
              <strong>{t("overviewCalendarFieldLable")}</strong>
            </Card.Header>
            <Card.Body
              className="d-flex justify-content-center"
              style={{
                maxWidth: "100%",
                width: "100%",
                overflowX: "auto", // 👈 enables horizontal scroll if overflow
                overflowY: "hidden", // optional, hides vertical scroll
                display: "flex",
                justifyContent: "center",
                paddingTop: "0px",
                paddingBottom: "0px"
              }}
            >
              <div
                style={{
                  minWidth: "280px", // 👈 ensures scroll appears only if needed
                }}
              >
                <CustomCalendar />
              </div>
            </Card.Body>
          </Card>
        </Col>


      </Row>

      {/* Row 3 - Resubmissions */}
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <strong>{t("overviewResubmissions")}</strong>
            </Card.Header>
            <Card.Body>
              <AllClaims filterPaymentStatus={filterPaymentStatus} approvalWindow="almostExpired" />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};
